"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@comunica/core");
/**
 * A logger that voids everything.
 */
class LoggerVoid extends core_1.Logger {
    debug(message, data) {
        // Void
    }
    error(message, data) {
        // Void
    }
    fatal(message, data) {
        // Void
    }
    info(message, data) {
        // Void
    }
    trace(message, data) {
        // Void
    }
    warn(message, data) {
        // Void
    }
}
exports.LoggerVoid = LoggerVoid;
//# sourceMappingURL=LoggerVoid.js.map